export const BASE_MONEY_FORMAT = new Intl.NumberFormat('fi-Fi', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})
